var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconWallet = function SvgIconWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.984,
    height: 15.736,
    viewBox: "0 0 17.984 15.736",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2,5.622H2.81a.562.562,0,0,1,0-1.124H16.3a.562.562,0,0,0,.562-.562A1.686,1.686,0,0,0,15.174,2.25H2.248A2.248,2.248,0,0,0,0,4.5v11.24a2.248,2.248,0,0,0,2.248,2.248H16.2A1.739,1.739,0,0,0,17.984,16.3V7.308A1.739,1.739,0,0,0,16.2,5.622Zm-1.588,7.306A1.124,1.124,0,1,1,15.736,11.8,1.124,1.124,0,0,1,14.612,12.928Z",
    transform: "translate(0 -2.25)",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wallet.48e3a3a7.svg";
export { ForwardRef as ReactComponent };